import { useEffect } from "react"
import LandingPage from './pages/LandingPage'
import MenuPage from './pages/MenuPage'
//import StoryMission from './pages/MissionAndStoryPage'
import {ResponsiveAppBar} from './components/Navbar'
import "./App.css"
import { Box } from "@mui/material"
import { Route, Routes, useLocation } from "react-router-dom"
import { Demodal } from "demodal"
//import CateringPage from "./pages/CateringPage"
import TodaysMenu from "./pages/MenuOfTheDay"
import VendingSchedule from "./pages/VendingSchedule"
import vendingSchedule from '../vendingSchedule.json'
import dayjs from "dayjs"
import { AnimatePresence } from 'motion/react'
import SliceTransition from './components/SliceTransition'
import MissionAndStoryPage from "./pages/MissionAndStoryPage"
import Lenis from '@studio-freight/lenis'
import TestimonialsPage from "./pages/Testimonials"
import { CateringPage } from "./pages/CateringPage"
import FoodTruckMenu from "./pages/FoodTruckMenu"

function AppContent() {
  const location = useLocation();

  useEffect( () => {
    const lenis = new Lenis()

    function raf(time:any) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  })
  
  return (
    <AnimatePresence mode="sync">
      <SliceTransition key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/TheGoods" element={<MenuPage />} />
          <Route path="/MediaAndTestimonials" element={<TestimonialsPage />} />
          {/* <Route path="/OurMission" element={<StoryMission />} /> */}
          <Route path="/Catering" element={<CateringPage />} />
          <Route path="/FoodTruckMenu" element={<FoodTruckMenu />} />
          <Route path="/VendingSchedule" element={<VendingSchedule data={vendingSchedule.schedule.filter(d => dayjs(d.date).isAfter(dayjs().subtract(1,'day')))}/>} />
          {/* <Route path="/HowTheSmokeGotRolling" element={<MissionAndStoryPage />} /> */}
        </Routes>
      </SliceTransition>
    </AnimatePresence>
  );
}

function App() {
  return (
    <>
      <ResponsiveAppBar />
      <AppContent />
      <Demodal.Container />
    </>
  )
}

export default App
